export default __webpack_public_path__ + "static/29-26c42ceeababba1c748b7ddb6f59e082.jpg";